import AntdDatePicker from 'antd/es/date-picker';
import { ComponentProps } from 'react';
import type { DatePickerProps } from 'antd/es/date-picker';
import type { Props } from './types';
import { RightIcon } from '@/assets/svgFile/DatePickerIcon';
import dayjs, { startOfWeek, endOfWeek } from '@/utils/dayjs';
import type { Dayjs } from '@/utils/dayjs';
import './style.scss';

function DatePicker(props: ComponentProps<typeof AntdDatePicker> & Props) {
    // 类型
    const type = props.picker || 'date';

    const formatHandle: DatePickerProps['format'] = (value) => {
        if (type === 'week') {
            const startDateOfWeek = startOfWeek(value);

            const endDateOfWeek = endOfWeek(value);

            const hasSameYear = dayjs(startDateOfWeek).isSame(endDateOfWeek, 'year');

            const fmStartDate = startDateOfWeek.format('DD MMM, YYYY').split(',');

            return `${hasSameYear ? fmStartDate[0] : fmStartDate.join(',')} - ${endDateOfWeek.format('DD MMM, YYYY')}`;
        } else if (type === 'month') return dayjs(value).format('MMM, YYYY');
        else if (type === 'year') return dayjs(value).format('YYYY');
        else return dayjs(value).format('DD MMM, YYYY');
    };

    const defaultProps = {
        suffixIcon: <RightIcon />,
        format: formatHandle,
    };

    return (
        <AntdDatePicker
            {...defaultProps}
            {...props}
            onChange={(value, dateString) => {
                const valueType = value as Dayjs;

                if (props.onChange) props.onChange(value, dateString);

                if (type === 'date' || type === 'week' || type === 'month' || type === 'year') {
                    const startOf = dayjs(valueType).startOf(type).format('YYYY-MM-DD');

                    const endOf = dayjs(valueType).endOf(type).format('YYYY-MM-DD');

                    if (props.onFormatChange) props.onFormatChange(startOf, endOf, valueType, dateString);
                }
            }}
        />
    );
}

export default DatePicker;
